import { ReactNode } from 'react'

import ChevronDownIcon from '~/components/Icons/svgs/ChevronDownIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'

export default function DropdownMenuHeader({
  children,
  dropdownIsOpen,
  onClick,
}: {
  children: ReactNode
  dropdownIsOpen: boolean
  onClick: () => void
}): React.ReactElement {
  return (
    <header className="p-4 flex items-center justify-between cursor-pointer " onClick={onClick}>
      <h3 className="min-w-0 mr-2 truncate font-semibold max-w-fit">{children}</h3>
      <div className="w-5 h-5 shrink-0 flex items-center justify-center rounded-full bg-blue-iris">
        <span className={`transform transition duration-300 ${dropdownIsOpen ? 'rotate-180' : ''}`}>
          <SVGIcon icon={ChevronDownIcon} pathClassName="text-white" size={10} />
        </span>
      </div>
    </header>
  )
}
